var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-overlay",
    _vm._b(
      {
        staticClass: "d-inline-block",
        attrs: {
          show: _vm.busy,
          rounded: "",
          opacity: "0.6",
          "spinner-small": "",
          "spinner-variant": "secondary"
        }
      },
      "b-overlay",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "b-button",
        _vm._b(
          {
            staticStyle: { padding: "1px 12px" },
            attrs: { variant: "secondary" },
            on: { click: () => _vm.showBillImgDetail() }
          },
          "b-button",
          _vm.$attrs,
          false
        ),
        [_vm._v("\n    Baixar\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }